import request from '../utils/request'
import { baseUrl } from './config';
export const doLogin = query => {
    return request({
        url: baseUrl+'/api/login',
        method: 'post',
        data: query
    })
}

export const loginnum = query => {
    return request({
        url: baseUrl+'/api/loginnum',
        method: 'get',
        params: query
    })
}

export const sendcode = query => {
    return request({
        url: baseUrl+'/api/sendcode',
        method: 'get',
        params: query
    })
}

export const codechangepwd = query => {
    return request({
        url: baseUrl+'/api/codechangepwd',
        method: 'post',
        data: query
    })
}

export const phonechangepwd = query => {
    return request({
        url: baseUrl+'/api/updatepwd_notLogIn',
        method: 'post',
        data: query
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js